export default function Footer() {
  return (
    <footer className="bg-[#0B2E33]/95 text-white">
      <div className="max-w-5xl mx-auto px-6 py-2 flex flex-col items-center">
        <div className="text-center">
          <p className="text-xs font-outfit">Developed by Aiswarya Pokharel.</p>
          <p className="text-xs font-outfit">Bhadrapur, Jhapa</p>
        </div>
      </div>
    </footer>
  );
}
